module.exports = __webpack_public_path__ + "static/1-7d95be19d2e819a542bcd5bc5353f38e.jpeg";